// Additional mock data for enhanced features

export const testimonials = [
  {
    id: 1,
    name: "Sarah M.",
    location: "Humble, TX",
    rating: 5,
    text: "After struggling with anxiety for years, Tawa helped me find peace and confidence. Her compassionate approach changed my life. I'm forever grateful.",
    service: "Anxiety Treatment",
    date: "2024"
  },
  {
    id: 2,
    name: "Michael R.",
    location: "Houston, TX",
    rating: 5,
    text: "The care I received for my ADHD was exceptional. Tawa listened to my concerns and created a treatment plan that actually works. Highly recommend!",
    service: "ADHD Management",
    date: "2024"
  },
  {
    id: 3,
    name: "Jennifer K.",
    location: "Humble, TX",
    rating: 5,
    text: "Finding help for my teenage daughter was challenging until we found FAVOR HCS. The compassionate care and understanding she received made all the difference.",
    service: "Child & Adolescent",
    date: "2023"
  },
  {
    id: 4,
    name: "David L.",
    location: "Atascocita, TX",
    rating: 5,
    text: "Professional, caring, and effective treatment. Tawa helped me manage my depression and get my life back on track. The entire process was respectful and supportive.",
    service: "Depression Care",
    date: "2024"
  }
];

export const faqs = [
  {
    id: 1,
    question: "Do you accept my insurance?",
    answer: "Yes! We accept 14+ insurance providers including Aetna, Blue Cross Blue Shield, Cigna, Humana, Medicare, UnitedHealthcare, and more. Check our Insurance section for the complete list, or call us at (281) 886-8595 to verify your specific plan."
  },
  {
    id: 2,
    question: "What should I bring to my first appointment?",
    answer: "Please bring a valid ID, your insurance card, a list of current medications, any previous medical records related to mental health, and a list of questions or concerns you'd like to discuss. Arriving 10-15 minutes early to complete paperwork is helpful."
  },
  {
    id: 3,
    question: "Do you prescribe medication?",
    answer: "Yes. As a board-certified psychiatric mental health nurse practitioner, Tawa Raji is qualified to prescribe medications when appropriate. She takes an integrative approach, combining medication management with therapy and lifestyle recommendations for comprehensive care."
  },
  {
    id: 4,
    question: "How long are sessions?",
    answer: "Initial consultations typically last 60-90 minutes to allow comprehensive evaluation. Follow-up appointments are usually 30-45 minutes. Session length may vary based on your individual needs and treatment plan."
  },
  {
    id: 5,
    question: "Is telehealth available?",
    answer: "Yes! We offer secure virtual appointments via video conferencing for your convenience. Telehealth sessions are perfect for follow-ups and medication management. Contact us to schedule your virtual visit."
  },
  {
    id: 6,
    question: "What ages do you treat?",
    answer: "We provide comprehensive psychiatric services for both children and adults. Our practice welcomes patients of all ages, from young children to seniors, with specialized approaches for each developmental stage."
  },
  {
    id: 7,
    question: "Do I need a referral?",
    answer: "While referrals are not required for most insurance plans, some may require one. We recommend checking with your insurance provider. You're welcome to self-refer and schedule directly by calling (281) 886-8595."
  },
  {
    id: 8,
    question: "What's your cancellation policy?",
    answer: "We require 24-hour advance notice for cancellations or rescheduling. Late cancellations or no-shows may incur a fee. We understand emergencies happen - please call us as soon as possible if you need to cancel or reschedule."
  }
];

export const officeHours = {
  monday: "9:00 AM - 6:00 PM",
  tuesday: "9:00 AM - 6:00 PM",
  wednesday: "9:00 AM - 6:00 PM",
  thursday: "9:00 AM - 6:00 PM",
  friday: "9:00 AM - 6:00 PM",
  saturday: "Closed",
  sunday: "Closed"
};

export const trustBadges = [
  {
    id: 1,
    title: "Board Certified",
    subtitle: "PMHNP-BC",
    icon: "Award"
  },
  {
    id: 2,
    title: "20+ Years",
    subtitle: "Clinical Experience",
    icon: "TrendingUp"
  },
  {
    id: 3,
    title: "HIPAA Compliant",
    subtitle: "Your Privacy Protected",
    icon: "Shield"
  },
  {
    id: 4,
    title: "Now Accepting",
    subtitle: "New Patients",
    icon: "UserPlus"
  }
];

export const whatToExpect = [
  {
    step: 1,
    title: "Schedule Consultation",
    description: "Call us or use our online form to book your initial appointment",
    icon: "Calendar"
  },
  {
    step: 2,
    title: "Complete Intake Forms",
    description: "Fill out paperwork about your medical history and current concerns",
    icon: "FileText"
  },
  {
    step: 3,
    title: "Initial Assessment",
    description: "60-90 minute comprehensive evaluation in a judgment-free environment",
    icon: "Clipboard"
  },
  {
    step: 4,
    title: "Personalized Treatment Plan",
    description: "Receive a customized plan tailored to your specific needs and goals",
    icon: "Target"
  },
  {
    step: 5,
    title: "Ongoing Support",
    description: "Regular follow-ups and adjustments to ensure optimal progress",
    icon: "HeartHandshake"
  }
];

export const successMetrics = {
  patientsSatisfaction: "90%",
  symptomsImprovement: "85%",
  wouldRecommend: "95%",
  averageRating: "4.9",
  patientsHelped: "500+"
};

export const blogPosts = [
  {
    id: 1,
    title: "5 Signs You Should See a Psychiatrist",
    excerpt: "Recognizing when it's time to seek professional help is crucial for your mental health. Learn the key indicators that it might be time to schedule an appointment.",
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800",
    category: "Mental Health",
    readTime: "5 min read",
    date: "2024"
  },
  {
    id: 2,
    title: "Understanding ADHD in Adults",
    excerpt: "ADHD isn't just a childhood condition. Discover how ADHD manifests in adults and effective management strategies for daily life.",
    image: "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=800",
    category: "ADHD",
    readTime: "7 min read",
    date: "2024"
  },
  {
    id: 3,
    title: "Managing Anxiety: Practical Tips That Work",
    excerpt: "Learn evidence-based techniques to manage anxiety and reduce stress in your daily life. Simple strategies that make a real difference.",
    image: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=800",
    category: "Anxiety",
    readTime: "6 min read",
    date: "2024"
  }
];

export const educationalVideos = [
  {
    id: 1,
    title: "Understanding Depression: Signs and Treatment",
    description: "Learn about depression symptoms, causes, and effective treatment options",
    thumbnail: "https://images.unsplash.com/photo-1488998427799-e3362cec87c3?w=800",
    duration: "4:32",
    category: "Depression",
    videoUrl: "https://www.youtube.com/embed/z-IR48Mb3W0" // Educational video about depression
  },
  {
    id: 2,
    title: "ADHD Explained: What You Need to Know",
    description: "A comprehensive overview of ADHD in children and adults",
    thumbnail: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800",
    duration: "5:15",
    category: "ADHD",
    videoUrl: "https://www.youtube.com/embed/xMWtGozn5jU" // Educational video about ADHD
  },
  {
    id: 3,
    title: "Anxiety Management Techniques",
    description: "Practical strategies to manage anxiety and reduce stress",
    thumbnail: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=800",
    duration: "6:20",
    category: "Anxiety",
    videoUrl: "https://www.youtube.com/embed/WWloIAQpMcQ" // Educational video about anxiety
  }
];

export const crisisResources = [
  {
    title: "988 Suicide & Crisis Lifeline",
    phone: "988",
    description: "24/7 free and confidential support",
    urgent: true
  },
  {
    title: "Crisis Text Line",
    phone: "Text HOME to 741741",
    description: "Free 24/7 crisis support via text",
    urgent: true
  },
  {
    title: "Emergency Services",
    phone: "911",
    description: "For immediate life-threatening emergencies",
    urgent: true
  },
  {
    title: "SAMHSA National Helpline",
    phone: "1-800-662-4357",
    description: "Treatment referral and information",
    urgent: false
  }
];

export const languages = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦' },
  { code: 'vi', name: 'Tiếng Việt', flag: '🇻🇳' },
  { code: 'ko', name: '한국어', flag: '🇰🇷' },
  { code: 'hi', name: 'हिन्दी', flag: '🇮🇳' }
];
